namespace GeniuzPOS.ReportMasterData {
    export interface Report_1502Form {
    }

    export class Report_1502Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1502';
    }
}
